import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { ProductInventoryData } from "../../../../interfaces/product";
import SwipingModal from "../../../shared/components/SwipingModal";
import SerialNumberLocations from "./SerialNumberLocations";
import { RotatedSortIcon } from "../../../shared/components/TableFilter";

const VerifyTable = ({
  data,
  handeSortChange,
  handleOrderTypeChange,
  order,
  orderType,
}: {
  data: ProductInventoryData[];
  handeSortChange: (state: "ASC" | "DESC") => void;
  handleOrderTypeChange: (type: string) => void;
  order: "ASC" | "DESC";
  orderType: string;
}) => {
  const [showProductCode, setShowProductCode] = useState<string>("");

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            table: {
              minWidth: 650,
            },
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("productCode");
                }}
              >
                Articolo
                {orderType === "productCode" && (
                  <IconButton>
                    <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell
                align="right"
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                QTA
                {orderType === "quantity" && (
                  <IconButton>
                    <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell
                align="right"
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                DISP
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: ProductInventoryData) => (
              <TableRow
                key={row.productCode}
                onClick={() => setShowProductCode(row.productCode)}
              >
                <TableCell component="th" scope="row">
                  {row.productCode}
                </TableCell>
                <TableCell align="right">{row.quantity}</TableCell>
                <TableCell align="right">
                  {row.quantity - row.pendingOrders}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <SwipingModal
        isOpen={showProductCode !== ""}
        title={`Ubicazione matricole ${showProductCode}`}
        titleLink={`/verify/serialNumbers?searchKeyword=${showProductCode}`}
        content={<SerialNumberLocations productCode={showProductCode} />}
        onClose={() => setShowProductCode("")}
      />
    </>
  );
};

export default VerifyTable;
